<template>
  <v-row dense align="center">
    <v-col cols="12" sm="4" class="text-truncate">
      <px-indicador-compra class="mr-2" :resposta="resposta"/>
      <px-status-negociacao :status-negociacao="resposta.statusNegociacao"/>
      <px-span-tooltip
        v-if="resposta.fornecedor.codigoInterno"
        bottom
        text-class="caption"
        :text="`(${resposta.fornecedor.codigoInterno})`"
        tooltip="Código interno do fornecedor"/>
      {{ resposta.fornecedor.pessoa.nome }}
      <px-popover-fornecedor :fornecedor-id="resposta.fornecedor.id" show-score/>
      <px-show-quantidade-produtos-homologados small
                                               :id-fornecedor="resposta.fornecedor.id"
                                               :produtos="cotacao.produtos"/>
      <px-show-fornecedor-com-difal small
                                    :produtos="resposta.produtos"/>
    </v-col>
    <v-col cols="12" sm="2">
      {{ resposta.frete.tipoFrete }}&nbsp;
      <div class="caption">
        {{ resposta.frete.prazoEntrega | pluralize(['dia útil', 'dias úteis']) }}
      </div>
    </v-col>
    <v-col cols="12" sm="3">
      <px-forma-pagamento :forma-pagamento="resposta.formaPagamento"
                          :prazo-pagamento="resposta.prazoPagamento"
                          :show-div="true"/>
    </v-col>
    <v-col cols="6" sm="2">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ resposta.valorMoedaConvertido.total | currency('R$', casaDecimal) }}
                  </span>
          <px-moeda-chip :moeda="moeda" v-if="isMoedaEstrangeira"/>
        </template>
        <span>Preço total</span>
      </v-tooltip>
      <div v-if="isMoedaEstrangeira" class="caption">
        <span>
          {{ resposta.total | currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda) }}
        </span>
      </div>
      <div class="caption">
        {{ resposta.quantidadeProdutos }}/{{ quantidadeProdutos }} produto(s)
      </div>
    </v-col>
    <v-col cols="6" sm="1">
      <div class="text-center">
        <px-favoritar-resposta v-if="hasRoleComprador"
                               :resposta="resposta"
                               :cotacao="cotacao"
                               @update="onUpdate"/>
        <template v-if="isModalView">
          <px-resposta-detalhes-dialog-view
            :cotacao-id="cotacao.id"
            :resposta-id="resposta.id"
          />
        </template>
        <template v-else>
          <v-btn icon small @click.stop="onClickDetalhes(resposta)">
            <v-icon>
              mdi-eye
            </v-icon>
          </v-btn>
        </template>
      </div>
    </v-col>
  </v-row>
</template>
<script lang="ts">
import Vue from 'vue';
import PxFavoritarResposta from '@/modules/cotacao/resposta/components/PxFavoritarResposta.vue';
import moedaMixin from '@/mixins/moeda-mixin';
import { mapGetters } from 'vuex';
import RespostaDetalhesDialogView
  from '@/modules/cotacao/resposta/detalhes/RespostaDetalhesDialogView.vue';

export default Vue.extend({
  mixins: [moedaMixin],
  props: {
    resposta: {
      type: Object,
      required: true,
    },
    cotacao: {
      type: Object,
      required: true,
    },
    casaDecimal: Number,
    isModalView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    moeda() {
      return this.resposta.moeda;
    },
    quantidadeProdutos() {
      return this.cotacao.quantidadeProdutos;
    },
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
    onClickDetalhes(item) {
      this.$router.push({
        name: 'main.cotacoes.respostas.detalhes',
        params: {
          id: this.cotacao.id,
          idResposta: item.id,
        },
      });
    },
  },
  components: {
    PxFavoritarResposta,
    pxRespostaDetalhesDialogView: RespostaDetalhesDialogView,
  },
});
</script>
